<template>

    <div v-if="show">

        <div class="columns">

            <div class="column is-narrow">

                <div class="menu">

                    <div v-for="(channel, index) in channels" :class="['menuItem', { 'is-active': activeChannel==channel }]" @click="activeChannel=channel">

                        <template v-if="channel.data.newsletterTitle != ''">
                            {{ channel.data.newsletterTitle }}
                        </template>
                        <template v-else>
                            {{ channel.name }}
                        </template>

                    </div>

                </div>

            </div>

            <div class="column">

                <template v-if="isLoading">
                    <loading-indicator></loading-indicator>
                </template>

                <template v-else>


                    <div class="centered">

                        <!--
                        <alert icon="exclamation" style="white-space: normal !important;">Bitte stellen Sie sicher, dass Sie ausschließlich E-Mail-Adressen von Personen hochladen und für Ihren Newsletter verwenden, deren Besitzer dem Empfang von Newslettern ausdrücklich zugestimmt haben.</alert>
                        -->

                        <!-- PHARMA.DIALOG && "News und Erfolge" -->
                        <vue-dropzone v-if="['pharma.dialog', 'News und Erfolge', 'apolounge'].indexOf(activeChannel.data.newsletterTitle) > -1 || activeChannel.name == 'Sanodat'"
                            ref="vueDropzoneXls"
                            id="vueDropzoneXls"
                            url= "fileProcessing/upload?preset=newsletterRecipients"
                            :formDataAppend="[{ channel: activeChannel.id } ]"
                            :maxFiles="1"
                            :thumbnailWidth="100"
                            :thumbnailHeight="100"
                            acceptedFiles= ".xls,.xlsx"
                            dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Excel Datei hochladen"
                            v-on:vdropzone-removed-file="dzRemoveFile"
                            v-on:vdropzone-mounted="dzInit"
                            v-on:vdropzone-success="dzSuccess"
                            style="margin-bottom: 25px;">
                        </vue-dropzone>

                        <v-client-table ref="tblNewsletterRecipients" name="tblNewsletterRecipients" :data="recipients" :columns="tbl.columns" :options="tbl.options" class="tbl-newsletterRecipients noFirstColumn">

                            <template slot="edit" slot-scope="props">

                                <pop-confirm class="icon is-small" content="Soll dieser Empfänger wirklich entfernt werden?" icon="question-circle-o" :on-ok="function() { recipientDelete(props) }" :on-cancel="cancel" cancel-text="nein" ok-text="löschen">
                                    <i class="icon-ak-entfernen" title="Empfänger entfernen"></i>
                                </pop-confirm>

                            </template>

                        </v-client-table>

                        <div class="has-text-centered buttons" style="margin-top: 25px;">
                            <export-button
                                v-if="recipients.length > 0"
                                export="complatNewsletterRecipients"
                                modalTitle="COMPLAT-NEWSLETTER-RECIPIENTS-MODAL_HEADER-EXPORT_RECIPIENTS"
                                btnTitle="COMPLAT-NEWSLETTER-RECIPIENTS-BTN-EXPORT"
                                :exportId="activeChannel.id"
                                style="margin-right: 6px;">
                            </export-button>
                            <template v-if="['BeiratsNews', 'ChefInfo', 'ManufacturerNews'].indexOf(activeChannel.data.newsletterTitle) > -1">
                                <custom-button icon="icon-ak-hinzufuegen" name="Empfänger hinzufügen" type="blue" @click.native="recipientAdd"></custom-button>
                            </template>
                        </div>

                    </div>


                    <!-- MODAL -->
                    <modal
                        :width="modal.width"
                        :title="modal.title"
                        transition="fadeDown"
                        cancel-text="Abbrechen"
                        :show-ok="false"
                        :backdrop-closable="false"
                        :is-show="showModal"
                        :class="modal.class"
                        @close="closeModal">

                            <template v-if="modal.isLoading">
                                <loading-indicator></loading-indicator>
                            </template>


                            <!-- PROGRESS NEWSLETTER RECIPIENT -->
                            <template v-else-if="modal.type == 'progress'">

                                <template v-if="progressStatus == null">

                                    <loading-indicator-small></loading-indicator-small>

                                </template>

                                <template v-else>

                                    <template v-if="progressStatus.status != 'Finished'">

                                        <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                                        <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                                    </template>

                                    <template v-else>

                                        <div class="has-text-centered">Empfänger erfolgreich hochgeladen</div>

                                    </template>

                                </template>

                            </template>

                            <!-- EDIT RECIPIENT -->
                            <template v-else-if="modal.type == 'recipientEdit'">

                                <div class="has-text-centered" :key="modal.type">
                                    <form-input label="SITE-NEWSLETTER-CHEFINFO-GENDER" :showLabel="true" :showLabelInOptions="true" inputType="select" selectFieldName="name" :selectOptions="personGenders" v-model="recipient.gender" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-TITLE" :inputType="text" v-model="recipient.title" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-FIRSTNAME" :inputType="text" v-model="recipient.firstname" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-LASTNAME" :inputType="text" v-model="recipient.lastname" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-EMAIL" :inputType="text" v-model="recipient.email" :is-horizontal="false"></form-input>
                                </div>

                                <div slot="footer">
        							<span class="button" @click="closeModal">abbrechen</span>
        							<span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="submitRecipient">speichern</span>
        						</div>

                            </template>

                            <!-- ADD RECIPIENT -->
                            <template v-else-if="modal.type == 'recipientAdd'">

                                <div class="has-text-centered" :key="modal.type">
                                    <form-input label="SITE-NEWSLETTER-CHEFINFO-GENDER" :showLabel="true" :showLabelInOptions="true" inputType="select" selectFieldName="name" :selectOptions="personGenders" v-model="recipient.gender" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-TITLE" :inputType="text" v-model="recipient.title" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-FIRSTNAME" :inputType="text" v-model="recipient.firstname" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-LASTNAME" :inputType="text" v-model="recipient.lastname" :is-horizontal="false"></form-input>
    								<form-input label="SITE-NEWSLETTER-CHEFINFO-EMAIL" :inputType="text" v-model="recipient.email" :is-horizontal="false"></form-input>
                                </div>

                                <div slot="footer">
        							<span class="button" @click="closeModal">abbrechen</span>
        							<span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="submitRecipient">hinzufügen</span>
        						</div>

                            </template>

                            <!-- SELECT -->
                            <template v-else-if="modal.type == 'select'">

                                <div class="has-text-centered">
                                    <form-input :label="'COMPLAT_NEWSLETTER_'+activeChannel.data.newsletterTitle.toUpperCase()" :showLabel="false" :showLabelInOptions="false" inputType="select" selectCustomLabel="customLabel" :selectIsSearchable="true" :selectOptions="selectBoxData" v-model="selectBoxDataSelected"></form-input>
                                </div>

                  						<div slot="footer">
                  							<span class="button" @click="closeModal">abbrechen</span>
                  							<span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="recipientAddSelected">weiter</span>
                  						</div>

                            </template>

                    </modal>

                </template>

            </div>


        </div>




    </div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');


import vue2Dropzone from '../../utils/dropzoneWrapper';
import exportButton from '../../utils/exportButton'



export default {

    props: {
        show: {
            type: Boolean,
            default: false
        },
        channels: {
            type: Array,
            default: function() { return [] }
        }
    },

    components: {
        vueDropzone: vue2Dropzone,
        exportButton
    },

    data() {

        return {
            isLoading: false,
            activeChannel: null,
            recipients: [],
            showModal: false,

            modal: {
                isLoading: false,
                isSaving: false,
                type: null,
                title: '',
                width: '640',
                class: 'progressModal'
            },

            refreshIntervalId: null,
            progressStatus: null,

            selectBoxData: [],
            selectBoxDataSelected: null,
            recipient: {},

			tbl: {
                // 'type', 'name', 'sendDate', 'status', 'subscribers', 'opens', 'clicks', 'edit
                // columns2: ['lastname', 'firstname', 'email', 'edit'],
                columns: ['lastname', 'firstname', 'email', 'edit'],
    			options: {
    				trackBy: 'id',
                    uniqueKey: 'id',
    				saveState: false,
    				perPage: 25,
    				orderBy: {
    					ascending: true,
    					column: 'lastname'
    				},

                    // custom table headings - make them clickable for language Setting
    				headings: {
                        lastname(h) {
    						return <lang labelKey="COMPLAT-NEWSLETTER-RECIPIENTS-TBL_HEADER-LASTNAME"></lang>
    					},
                        firstname(h) {
    						return <lang labelKey="COMPLAT-NEWSLETTER-RECIPIENTS-TBL_HEADER-FIRSTNAME"></lang>
    					},
    					email(h) {
    						return <lang labelKey="COMPLAT-NEWSLETTER-RECIPIENTS-TBL_HEADER-EMAIL"></lang>
    					},
                        edit(h) {
    						return '';
    					},
    				},

    				sortable: ['lastname', 'firstname', 'email'],
    				sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

    				filterByColumn: false,
    				filterable: false,

    				texts: {
    					filter: 'Filter Ergebnisse:',
    					filterPlaceholder: 'Suche',
    					limit: 'Einträge pro Seite',
    					noResults: 'keine passenden Einträge gefunden',
    					count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
    				},

    				pagination: {
    					chunk: 5
    				},

    				skin: 'table is-striped is-hoverable is-fullwidth',

    				// custom filter functions
    				customFilters: [

    				],

    				// custom sorting functions
    				customSorting: {

    				}

    			}
           }
        }
    },

    watch: {

        activeChannel(val) {

            this.fetchChannelRecipients(val.id);

        }

    },

    computed: {

        personGenders() {
			return this.$store.getters.getTermsByTaxonomy('PERSON_GENDERS');
		},

    },

    created() {

        this.activeChannel = this.channels[0];

    },

    mounted() {


    },


    methods: {

        recipientAdd() {

            this.modal.type = 'select';
            this.modal.title = 'Empfänger hinzufügen';
            this.modal.width = '640';
            this.modal.class = 'recipientEditModal';
            this.showModal = true;
            this.modal.isLoading = true;

            var self = this;

            this.fetchSelectBoxData()
                .then(function(response) {
                    self.modal.isLoading = false;
                });

        },


        recipientAddSelected() {

            this.modal.type = 'recipientAdd';
            this.modal.title = 'Empfänger hinzufügen';

            // TODO:
            // this.recipientEdit();

        },

        recipientEdit() {

            this.modal.isSaving = false;
            this.modal.type = 'recipientEdit';
            this.modal.title = 'Empfänger bearbeiten';
            this.modal.width = '640';
            this.modal.class = 'recipientEditModal';
            this.showModal = true;
            this.modal.isLoading = true;

            var self = this;



            // TODO: fetch recipient by ID
            // fetch manufacturer OR pharmacy to get recipient information
            // assign: this.selectBoxDataSelected = [id]
            // assign: this.recipient = {}

            /*
            this.activeChannel.data.newsletterTitle == 'ManufacturerNews'
            this.activeChannel.data.newsletterTitle == 'ChefInfo'
            this.activeChannel.data.newsletterTitle == 'BeiratsNews'
            */

            setTimeout(function() {
                self.modal.isLoading = false;
            }, 2000)


        },

        submitRecipient() {

            this.modal.isSaving = true;
            // console.log("recipient: ", this.recipient);
            // return;

            if(this.recipient.email == '' || !this.validateEmail(this.recipient.email)) {
                this.$notify.open( { content: 'Bitte geben Sie eine valide Email Adresse ein!', type: 'warning'});
                this.modal.isSaving = false;
                return;
            }
            else if(!this.recipient.lastname || this.recipient.lastname == '') {
                this.$notify.open( { content: 'Bitte geben Sie zumindest einen Nachnamen ein!', type: 'warning'});
                this.modal.isSaving = false;
                return;
            }

            var self = this;

            // bereitsnews
            if(this.activeChannel.data.newsletterTitle == 'BeiratsNews') {

                let obj = {
                    id: this.selectBoxDataSelected.id,
                    isBeiratsNewsNewsletterRecipient: true,
                    beiratsNewsNewsletterRecipient: this.recipient
                }

                this.entityCreateOrUpdate('site', obj, { isSilent: true })
                    .then(function(response) {
                        self.$notify.open({ content: 'Empfänger wurde erfolgreich hinzugefügt', type: 'success' });
                        self.fetchChannelRecipients(self.activeChannel.id);
                        self.closeModal();
                    });

            }

            // chefinfo
            else if(this.activeChannel.data.newsletterTitle == 'ChefInfo') {

                let obj = {
                    id: this.selectBoxDataSelected.id,
                    isChefinfoNewsletterRecipient: true,
                    chefinfoNewsletterRecipient: this.recipient
                }

                this.entityCreateOrUpdate('site', obj, { isSilent: true })
                    .then(function(response) {
                        self.$notify.open({ content: 'Empfänger wurde erfolgreich hinzugefügt', type: 'success' });
                        self.fetchChannelRecipients(self.activeChannel.id);
                        self.closeModal();
                    });

            }

            // manufacturer
            else if(this.activeChannel.data.newsletterTitle == 'ManufacturerNews') {

                let obj = {
                    id: this.selectBoxDataSelected.id,
                    isManufacturerNewsNewsletterRecipient: true,
                    manufacturerNewsNewsletterRecipient: this.recipient
                }

                this.entityCreateOrUpdate('manufacturer', obj, { isSilent: true })
                    .then(function(response) {
                        self.$notify.open({ content: 'Empfänger wurde erfolgreich hinzugefügt', type: 'success' });
                        self.fetchChannelRecipients(self.activeChannel.id);
                        self.closeModal();
                    });

            }

        },

        dzSuccess(file, response) {

            var self = this;

            this.modal.isLoading = false;
            this.modal.isSaving = false;
            this.modal.type = 'progress';
            this.modal.title = 'Verarbeitung';
            this.modal.width = '640';
            this.modal.class = 'progressModal';

            this.showModal = true;

            this.$refs.vueDropzoneXls.$children[0].removeAllFiles();
            let taskLogId = response.taskLogId;

            self.refreshIntervalId = setInterval(function() {

                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                    .then(function(response) {

                        self.progressStatus = response.data;

                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                            clearInterval(self.refreshIntervalId);

                            self.fetchChannelRecipients(self.activeChannel.id)
                                .then(() => {

                                    self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                    self.closeModal();

                                })
                        }

                    });

            }.bind(self), 1000);


            setTimeout(function() {

                clearInterval(self.refreshIntervalId);
                self.showModal = false;

            }, 100000);


        },

        closeModal() {

            this.showModal = false;

            // in case we've running an interval
            clearInterval(this.refreshIntervalId);

            this.refreshIntervalId = null;
            this.progressStatus = null;
            this.modal.isSaving = false;
            this.modal.title = "";

        },

        recipientDelete(props) {

            let email = props.row.email;
            var index = this.recipients.findIndex(recipient => recipient.id == props.row.id);

            var self = this;
            this.axios.get(this.$config.api + 'newsletter/unsubscribeByChannel?channel='+this.activeChannel.id+'&subscriberEmail='+email)
                .then(function(response) {
                    self.recipients.splice(index, 1);
                    self.$notify.open({ content: 'Empfänger wurde erfolgreich entfernt', type: 'success'});
                })

        },

        fetchSelectBoxData() {

            var self = this;
            self.selectBoxData = [];
            self.selectBoxDataSelected = null;

            return new Promise(function(resolve, reject) {

                if(['BeiratsNews', 'ChefInfo'].indexOf(self.activeChannel.data.newsletterTitle) > -1) {

                    self.axios.get(self.$config.api + 'siteCatalog/liteList?catalog='+self.catalogId+'&orderBy=siteCatalog.site.name')
                        .then(response => {

                            response.data.siteCatalog.forEach(site => {
                                self.selectBoxData.push({
                                    id: site.site.id,
                                    name: site.site.name,
                                    customLabel: site.site.name + ' (#'+site.site.extRef+')'
                                })
                            })

                            resolve();

                        })

                } else if(self.activeChannel.data.newsletterTitle == 'ManufacturerNews') {

                    self.axios.get(self.$config.api + 'manufacturer?orderBy=name')
                        .then(response => {

                            response.data.manufacturer.forEach(manufacturer => {
                                self.selectBoxData.push({
                                    id: manufacturer.id,
                                    name: manufacturer.name,
                                    customLabel: manufacturer.name + ' (#'+manufacturer.extRef+')'
                                })
                            });

                            resolve();

                        })
                }



            });

        },

        fetchChannelRecipients(channelId) {

            this.isLoading = true;

            var self = this;

            return new Promise(function(resolve, reject) {

                self.axios.get(self.$config.api + 'newsletter/subscribersByChannel?channel='+channelId)
                .then(response => {
                    // console.log(response.data);
                    self.recipients = response.data;
                    self.isLoading = false;
                    resolve();
                })

            })
        }

    }

}
</script>


<style lang="scss" scoped>

	@import '~../../../assets/css/variables.scss';

    .centered {
        /*max-width: 700px;*/
        max-width: 95%;
        margin: 0 auto;
    }

    .menu {
        border: none;
        box-shadow: none;
        min-width: 150px;
    }
    .menu .menuItem {
        cursor: pointer;
        transition: all .3s ease;
    }
    .menu .menuItem:hover,
    .menu .menuItem.is-active {
        color: $themeColor1Hover;
    }

    .columns .column >>> .v-spinner {
        height: 15vh !important;
    }

</style>

<style scoped>

    >>> .tbl-newsletterRecipients th:last-child {
        width: 80px;
        max-width: 80px;
    }
    >>> .modal-card-body .has-text-centered {
        max-width: 450px;
        width: 100%;
        margin: 0 auto;
    }

    .buttons > div {
        display: inline-block;
    }
</style>
